import { render, staticRenderFns } from "./newsListPage.vue?vue&type=template&id=e278b998&"
import script from "./newsListPage.vue?vue&type=script&lang=ts&"
export * from "./newsListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports